export const staff = {
  page_heading: "Staff",
  editor_label_identifier: "ID",
};
